/**
 * Stable serial (1-based) across pagination for MUI DataGrid client-side pagination.
 * `getRowIndexRelativeToVisibleRows` alone resets to 1 on each page.
 */
export function getDataGridGlobalSerialNumber(params) {
  const api = params.api;
  const pm = api.state?.pagination?.paginationModel;
  const page = pm?.page ?? 0;
  const pageSize = pm?.pageSize ?? 10;
  const relativeIndex = api.getRowIndexRelativeToVisibleRows(params.id);
  return page * pageSize + relativeIndex + 1;
}
